import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { ArrowLeft, Mail } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // Backend responds identically whether the email exists or not, so we always show "sent"
            await axios.post(`${API_URL}/api/auth/forgot-password`, null, { params: { email: email.trim().toLowerCase() } });
            setSent(true);
        } catch (err) {
            toast.error(err.response?.data?.detail || t('common.error_generic'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F9F6F0]">
            <Navbar />
            <main className="pt-24 pb-16" data-testid="forgot-password-page">
                <div className="max-w-md mx-auto px-6 sm:px-8">
                    <Link to="/login" className="inline-flex items-center gap-2 text-sm text-[#5B2D8E] hover:underline mb-8" data-testid="back-to-login">
                        <ArrowLeft className="w-4 h-4" /> {t('auth.back_to_login')}
                    </Link>
                    <p className="overline mb-3">{t('auth.forgot_heading')}</p>
                    <h1 className="heading-2 mb-4">{t('auth.forgot_heading')}</h1>
                    <p className="body-text mb-8">{t('auth.forgot_sub')}</p>

                    {sent ? (
                        <div className="bg-white border border-[#E5E0D8] rounded-sm p-6" data-testid="forgot-password-sent">
                            <div className="flex items-start gap-3">
                                <Mail className="w-5 h-5 text-[#5B2D8E] mt-1" />
                                <div>
                                    <p className="font-serif text-lg text-[#1A1A2E] mb-1">{t('auth.reset_sent_title')}</p>
                                    <p className="text-sm text-[#4A4A68]">{t('auth.reset_sent_body', { email })}</p>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <form onSubmit={onSubmit} className="space-y-4 bg-white border border-[#E5E0D8] rounded-sm p-6" data-testid="forgot-password-form">
                            <div>
                                <label className="block font-sans text-sm text-[#1A1A2E] mb-2">{t('auth.email')}</label>
                                <input
                                    type="email"
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="you@example.com"
                                    className="w-full"
                                    data-testid="forgot-password-email"
                                />
                            </div>
                            <button
                                type="submit"
                                disabled={loading || !email.trim()}
                                className="btn-primary w-full"
                                data-testid="forgot-password-submit"
                            >
                                {loading ? t('auth.sending') : t('auth.send_reset_link')}
                            </button>
                        </form>
                    )}
                </div>
            </main>
            <Footer />
        </div>
    );
}
